import Grid, { GridProps } from '@mui/material/Grid';

interface Props extends GridProps {}

export const CenterPositionedCol = (props: Props) => {
  return (
    <Grid
      {...props}
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ ...props.sx }}
    />
  );
};
